
import React, { useState } from 'react';
import ProductDisplay from '../../components/ProductDisplay';
// import Carousel from '../components/Carousel';
import Carousel from '../../components/Carousel.js'
import CarouselComponent from '../../components/CarouselComponent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import tech1 from "../../assests/technology (1).png";
import tech2 from "../../assests/technology (2).png";
import tech3 from "../../assests/plasmOX.png";
// import aop1 from 'product/aop.png'
// import FAQSection from '../components/FAQSection';
function Corrosion() {
	const [openFAQ, setOpenFAQ] = useState(null);

	const faqs = [
		{
			id: 1,
			question: "Features",
			answer: {
				type: "iconText",
				iconContent: [
					{
						// icon: "../product/aop/Group 121.png",
						// text: "Our return policy is...",
						image: "../product/CS/Group 165.png",
						additionalText: "Dampers are provided for pressurization (if required)"
					},
					{
						// icon: "../product/aop/Group 122.png",
						// text: "Our shipping policy is...",
						image: "../product/CS/Group 165.png",
						additionalText: "Electronic fan’s are used for the High Energy Efficiency."
					},
					{
						// icon: "../product/aop/Group 124.png",
						// text: "Our warranty policy is...",
						image: "../product/CS/Group 165.png",
						additionalText: "Dust filters are provided for  the Trapping of Dust Particles"
					},
					{
						// icon: "../product/aop/Group 125.png",
						// text: "Our support policy is...",
						image: "../product/CS/Group 165.png",
						additionalText: "Controllers is provided which gives same machine to run from 20% to 120%"
					},
					{
						// icon: "../product/aop/Group 125.png",
						// text: "Our support policy is...",
						image: "../product/CS/Group 165.png",
						additionalText: "Painted 14G single skin with insulation inside"
					},
					{
						// icon: "../product/aop/Group 125.png",
						// text: "Our support policy is...",
						image: "../product/CS/Group 165.png",
						additionalText: "Grid Matrix filters are used for low static pressure"
					},

				]
			}
		},
		{
			id: 2,
			question: "Benefits",
			answer: {
				type: "list",
				items: ["To maintain data centers equipment reliability & elimination of corrosive contaminants.",
					"This Fresh Air Unit/Recirculation tackle the problems of gaseous contamination and to safeguard electronic media. ",
					"Air scrubbing equipment that specifically remove the H2S and SO2 in the indoor air and bring the severity levels to G1 (mild) as per ISA Standards",
					"Designed for removing toxic, corrosive and odorous gases, (acid gases, aldehydes, amines).",
					"Chemical Filters use the adsorption and the Chemisorption process to Treat the Gaseous Contamination both Organic / Inorganic compound ."]
			}
		},
		{
			id: 3,
			question: "Targeted Gases",
			answer: {
				type: "images",
				images: ["../product/ultrasorb/H2s.png", "../product/ultrasorb/Asset 14.png", "../product/ultrasorb/Asset 13.png", "../product/ultrasorb/Asset 12.png", "../product/ultrasorb/Asset 11.png", "../product/ultrasorb/Asset 10.png"],
				imagescontent: ["Hydrogen Sulphie", "Nitrogen Oxides ", "Sulphur Dioxide", "Ammonia ", "Formaldehyde", "Chlorine",]

			}
		},
		{
			id: 4,
			question: "Application Area",
			answer: {
				type: "words",
				words: [
					"Data Centers",
					"Airports",
					"Halls and Malls",
					"Hotels",
					"Offices",
					"Industrial Facilities",
					"Power Generation",
					"Public Transportation",
					"Pulp and Paper",
					"Refineries",
					"Water/Wastewater Treatment",
					"Material Processing",
					"Food and Beverage Industry",
					"Commercial and Public Buildings",
					"Museums and Cultural Institutions",


				]
			}
		}
	];



	const product = {
		headingText: "FOR CORROSION CONTROL",
		title: "Electronic Corrosion Control Unit",

		downloadFile: "https://ultrapureindia.in/pdf/Data%20Centre%20Catalog.pdf",
		mainImage: 'product/ccu/Group 179.png',
		relativeImages: [
			"./Product/aop.png",
			"./Product/aop.png",
			"./Product/aop.png",
			"./Product/aop.png",
		],
	};
	const toggleFAQ = (id) => {
		setOpenFAQ(openFAQ === id ? null : id);
	};

	return (
		<div className="overflow-x-hidden">
			<ProductDisplay
				headingText={product.headingText}
				title={product.title}
				downloadFile={product.downloadFile}
				mainImage={product.mainImage}
				relativeImages={product.relativeImages}
			/>
			<div className="flex flex-col md:flex-row  p-4 md:p-8 rounded-lg">
				<div className="w-full md:w-1/2 mt-4 md:mt-0 md:ml-6 flex flex-col justify-center">
					{/* <h2 className='text-gray-700 px-8 text-justify font-bold'>Product Info</h2> */}
					<p className="text-gray-700 px-8 text-justify">
						The Electronic Corrosion Control Unit is a self-contained air filtration and purification system specifically designed to provide clean, pressurized air free from corrosive gases and airborne contaminants. The system helps maintain ISA G1 environmental conditions within critical electronic and electrical equipment rooms, ensuring the reliable operation and extended life of sensitive equipment.<br /><br />
						Designed as a standalone solution, the unit can be configured for both recirculation air treatment and fresh air purification. Utilizing ultraSORB® Grid Matrix filtration technology, it effectively removes corrosive contaminants that can cause, electrical failures, and premature equipment degradation.</p>
				</div>
				<div className="w-full md:w-1/2 flex justify-between items-center">
					<div className="m-auto">
						<h6 className="text-xl font-bold text-sm">Powered by</h6>
						<img src={tech2} alt="plasma" className=" h-auto rounded-lg" />
					</div>

					{/* <div className="w-1/2">
						<img src={tech3} alt="plasma" className=" h-auto rounded-lg" />
						<h6 className="font-bold w-full text-sm">plasmOX® Technology</h6>
					</div> */}
				</div>
			</div>
			{/* faq */}
			<div className="mx-auto bg-white p-8 rounded-lg shadow-lg">
				{faqs.map((faq) => (
					<div key={faq.id} className="mb-4">
						<button
							className={`w-full text-left p-4 rounded-full flex justify-between items-center focus:outline-none transition-colors duration-300 ${openFAQ === faq.id
								? "bg-gradient-to-r from-textBlue to-ultragreen text-white"
								: "bg-gray-200 text-black"
								}`}
							onClick={() => toggleFAQ(faq.id)}
						>
							<span className="text-lg font-bold">{faq.question}</span>
							<FontAwesomeIcon
								icon={openFAQ === faq.id ? faChevronDown : faChevronRight}
							/>
						</button>
						{openFAQ === faq.id && (
							<div className="p-4 bg-gray-100 rounded-lg">
								{faq.answer.type === "iconText" && (
									<div className="space-y-4 flex flex-wrap">
										{faq.answer.iconContent.map((content, index) => (
											<div key={index} className="flex sm:flex-wrap items-center w-full lg:w-1/4  p-3">
												{/* <img src={content.icon} alt="Icon" className="h-6 w-6 mr-2" />
												<span>{content.text}</span> */}
												<div className="flex items-center">
													<img src={content.image} alt="product" className="h-15 w-15 mx-2" />
													<span>{content.additionalText}</span>
												</div>
											</div>
										))}
									</div>
								)}
								{faq.answer.type === "list" && (
									<ul className="list-disc list-inside">
										{faq.answer.items.map((item, index) => (
											<li key={index}>{item}</li>
										))}
									</ul>
								)}
								{faq.answer.type === "images" && (
									<div className="grid grid-cols-3 sm:grid-cols-3 lg:grid-cols-6 gap-4">
										{faq.answer.images.map((image, index) => (
											<div key={index} className="text-center">
												<img src={image} alt={`Image ${index + 1}`} className=" mx-auto" />
												<span className="block mt-2">{faq.answer.imagescontent[index]}</span>
											</div>
										))}
									</div>
								)}
								{faq.answer.type === "words" && (
									<div className="gap-2 grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-4 ml-5">
										{faq.answer.words.map((word, index) => (
											<li key={index}>{word}</li>
										))}
									</div>
								)}
							</div>
						)}
					</div>
				))}
			</div>


			{/* product carousel */}
			{/* <Carousel /> */}
			{/* client tested carousel	 */}
			<CarouselComponent />
		</div>
	);
}

export default Corrosion;
